import React from "react";
import { HOST_URL } from '../../helpers/constants/Constants'
import { saveData } from '../../helpers/axios/Post'

class ReportRow extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      success: false,
      running: false,
      failed: false
    }
  }

  initializedCall = () => {
    this.setState({
      running: true
    })
  }

  getResponse = (response) => {

    if (response.status === 200) {
      this.setState({
        success: true,
        running: false
      })
    } else {
      this.setState({
        failed: true,
        running: false
      })
    }
  }

  generateReport = (event) => {
    const config = {
      method: 'post',
      url: HOST_URL + '/api/createreport',
      headers: { 'content-type': 'application/json' },
      withCredentials: true,
      data: {
        userId: this.props.user,
        projectid: this.props.projectid,
        report_id: this.props.report.report_id,
        report_name: this.props.report.report_title,
        bim360_folder_id: this.props.report.bim360_folder_id,
        fileType: this.props.settings.reportsExtension,
        fmejob: this.props.report.fmejob,
        schema: this.props.report.schema,
        PLM_project_id: this.props.PLM_project_id
      }
    };

    saveData(config, this.getResponse, this.initializedCall)
  }

  render() {
    const {
      report_id,
      report_title,
      description
    } = this.props.report;

    const {
      success,
      running,
      failed,
    } = this.state;


    return (
      <tr
        key={report_id}
        title={'Create and upload report to BIM 360'}
        onClick={this.generateReport}>
        <th className="text-nowrap">{report_title}</th>
        <td>{description}</td>
        <th className={`report-load ${running ? 'data-loading' : 'no-data-loading'}`}>
          <button className={`btn btn-icon ${success ? 'icon-file-success' : failed ? 'icon-file-danger' : 'icon-file-add'}`}>
            <span className="sr-only">Create-report</span>
          </button>
          <div className="sk-circle">
            <div className="sk-circle1 sk-child" />
            <div className="sk-circle2 sk-child" />
            <div className="sk-circle3 sk-child" />
            <div className="sk-circle4 sk-child" />
            <div className="sk-circle5 sk-child" />
            <div className="sk-circle6 sk-child" />
            <div className="sk-circle7 sk-child" />
            <div className="sk-circle8 sk-child" />
            <div className="sk-circle9 sk-child" />
            <div className="sk-circle10 sk-child" />
            <div className="sk-circle11 sk-child" />
            <div className="sk-circle12 sk-child" />
          </div>
        </th>
      </tr>
    )
  }
}

export default ReportRow;